module.exports = __webpack_public_path__ + "img/002王霞.cf7500bd.jpg";